<template>
  <div class="tradeOrderReconciliation">
    <van-form label-width="120px">
      <div v-if="content.PaymentList">
        <div class="cost-title">{{ $t.tradeOrder.nuType2 }}</div>
        <van-collapse v-model="active1" v-if="content.PaymentList.length > 0">
          <van-collapse-item
            v-for="(item, index) in content.PaymentList"
            :title="item.FinancialAccountNo"
            :name="index"
            :key="index"
          >
            <div class="collapse-item">
              {{ $t.tradeOrder.financialAccountNo }}：{{ item.FinancialAccountNo }}
            </div>
            <div class="collapse-item">
              {{ $t.tradeOrder.customerNumber }}：{{ item.CustomerNumber }}
            </div>
            <div class="collapse-item">
              {{ $t.tradeOrder.companyNameSn }}：{{ item.CompanyNameSn }}
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.tradeOrder.totalPayable }}</div>
              <div
                class="collapse-amount"
                v-for="(item, index) in item.TotalAmountList"
                :key="index"
              >
                {{ item.key }}：{{ item.value }}
              </div>
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.tradeOrder.totalPayableBalance }}</div>
              <div
                class="collapse-amount"
                v-for="(item, index) in item.BalanceAmountList"
                :key="index"
              >
                {{ item.key }}：{{ item.value }}
              </div>
            </div>
            <div class="collapse-buttons">
              <van-button
                type="info"
                size="small"
                @click="toSupplierCostEntry(item.FinancialAccountNo)"
                >{{ $t.tradeOrder.viewCost }}</van-button
              >
              <van-button
                type="danger"
                size="small"
                @click="dialogShow(1, item.FinancialAccountNo)"
                >{{ $t.tradeOrder.deleteCost }}</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="empty-text" v-else>{{ $t.meta.noData }}</div>

        <div class="subTotal" v-if="content.RateList.length > 0">
          <div class="subTotal-label">{{ $t.tradeOrder.subTotal }}</div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[0].CurrencySn }}</div>
            <div class="item2">{{ content.Currency1_PaymentSubtotal }}</div>
          </div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[1].CurrencySn }}</div>
            <div class="item2">{{ content.Currency2_PaymentSubtotal }}</div>
          </div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[2].CurrencySn }}</div>
            <div class="item2">{{ content.Currency3_PaymentSubtotal }}</div>
          </div>
        </div>

        <div class="rate">
          <div class="rate-label">{{ $t.tradeOrder.rate }}</div>
          <div class="rate-item" v-for="(item, index) in content.RateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <van-field
          style="border-top: 1px solid #ebedf0"
          v-model="content.PaymentTotalAmount"
          :label="$t.tradeOrder.totalAmount + ' ( ' + content.SettlementCurrency + ' ) '"
          readonly
        />
      </div>

      <div v-if="content.ReceivableList">
        <div class="sale-title">{{ $t.tradeOrder.nuType1 }}</div>
        <van-collapse v-model="active2" v-if="content.ReceivableList.length > 0">
          <van-collapse-item
            v-for="(item, index) in content.ReceivableList"
            :title="item.InvoiceNo"
            :name="index"
            :key="index"
          >
            <div class="collapse-item">
              {{ $t.tradeOrder.invoiceNo }}：{{ item.InvoiceNo }}
            </div>
            <div class="collapse-item">
              {{ $t.tradeOrder.customerNumber }}：{{ item.CustomerNumber }}
            </div>
            <div class="collapse-item">
              {{ $t.tradeOrder.companyNameSn }}：{{ item.CompanyNameSn }}
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.tradeOrder.totalReceive }}</div>
              <div
                class="collapse-amount"
                v-for="(item, index) in item.TotalAmountList"
                :key="index"
              >
                {{ item.key }}：{{ item.value }}
              </div>
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.tradeOrder.totalReceiveBalance }}</div>
              <div
                class="collapse-amount"
                v-for="(item, index) in item.BalanceAmountList"
                :key="index"
              >
                {{ item.key }}：{{ item.value }}
              </div>
            </div>
            <div class="collapse-buttons">
              <van-button
                type="info"
                size="small"
                @click="toBillsReceivable(item.InvoiceNo)"
                >{{ $t.tradeOrder.viewSell }}</van-button
              >
              <van-button
                type="danger"
                size="small"
                @click="dialogShow(2, item.InvoiceNo)"
                >{{ $t.tradeOrder.deleteSell }}</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="empty-text" v-else>{{ $t.meta.noData }}</div>
        <div class="subTotal" v-if="content.RateList.length > 0">
          <div class="subTotal-label">{{ $t.tradeOrder.subTotal }}</div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[0].CurrencySn }}</div>
            <div class="item2">{{ content.Currency1_ReceivableSubtotal }}</div>
          </div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[1].CurrencySn }}</div>
            <div class="item2">{{ content.Currency2_ReceivableSubtotal }}</div>
          </div>
          <div class="subTotal-item">
            <div class="item1">{{ content.RateList[2].CurrencySn }}</div>
            <div class="item2">{{ content.Currency3_ReceivableSubtotal }}</div>
          </div>
        </div>

        <div class="rate">
          <div class="rate-label">{{ $t.tradeOrder.rate }}</div>
          <div class="rate-item" v-for="(item, index) in content.RateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <van-field
          style="border-top: 1px solid #ebedf0"
          v-model="content.ReceivableTotalAmount"
          :label="
            $t.tradeOrder.receTotalAmount + ' ( ' + content.SettlementCurrency + ' ) '
          "
          readonly
        />

        <van-field
          v-model="content.ProfitsTotalAmount"
          :label="
            $t.tradeOrder.profitTotalAmount + ' ( ' + content.SettlementCurrency + ' ) '
          "
          readonly
        />
      </div>
    </van-form>

    <van-dialog
      :title="$t.tradeOrder.notice"
      width="90%"
      v-model="showDialog"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        <div v-if="dialogType == 1">{{ $t.tradeOrder.deleteCheck1 }}</div>
        <div v-if="dialogType == 2">{{ $t.tradeOrder.deleteCheck2 }}</div>
      </div>
    </van-dialog>

    <van-action-sheet v-model="sheetShow" :actions="sheetActions" @select="sheetSelect" />

    <div class="tool-bar">
      <van-button type="info" block @click="handleSheetShow">{{
        $t.meta.menu
      }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Collapse,
  CollapseItem,
  ActionSheet,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Collapse)
  .use(CollapseItem)
  .use(ActionSheet);

export default {
  name: "tradeOrderReconciliation",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      TOId: "",
      content: {},
      active1: [],
      active2: [],
      //弹窗
      showDialog: false,
      dialogType: 1,
      dialogId: "",
      //操作菜单
      sheetShow: false,
      sheetActions: [],
    };
  },
  created() {
    const { TOId } = this.$route.query;
    this.TOId = TOId;
    this.getList();
  },
  methods: {
    sheetSelect(e) {
      if (e.className == "1") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "billsReceivable",
          name: "billsReceivable",
          query: [
            {
              name: "TOId",
              value: this.TOId,
            },
          ],
        });
      }
      if (e.className == "2") {
        this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
          isParams: true,
          path: "supplierCostEntry",
          name: "supplierCostEntry",
          query: [
            {
              name: "TOId",
              value: this.TOId,
            },
          ],
        });
      }
      this.sheetShow = false;
    },
    handleSheetShow() {
      var actions = [
        { name: this.$t.tradeOrder.sheet1, className: "1" },
        { name: this.$t.tradeOrder.sheet2, className: "2" },
      ];
      this.sheetActions = actions;
      this.sheetShow = true;
    },
    toBillsReceivable(InvoiceNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: InvoiceNo,
          },
        ],
      });
    },
    toSupplierCostEntry(FinancialAccountNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "supplierCostEntry",
        name: "supplierCostEntry",
        query: [
          {
            name: "FinancialAccountNo",
            value: FinancialAccountNo,
          },
        ],
      });
    },
    dialogConfirm() {
      if (this.dialogType == 1) {
        this.deleteSupplierCostDetails(this.dialogId);
      }
      if (this.dialogType == 2) {
        this.deleteCollectionBill(this.dialogId);
      }
      this.showDialog = false;
    },
    dialogCancel() {
      this.dialogType = 1;
      this.dialogId = "";
      this.showDialog = false;
    },
    dialogShow(type, id) {
      this.dialogType = type;
      this.dialogId = id;
      this.showDialog = true;
    },
    getList() {
      this.$commonMethod.showLoading();
      var param = {
        TOId: this.TOId,
      };
      this.$api.purchasingManagement
        .tradeOrderCustomerAccountReconciliation(param)
        .then((res) => {
          this.content = res.data;
          if (this.content.PaymentList && this.content.PaymentList.length > 0) {
            for (var item of this.content.PaymentList) {
              this.getDic(item);
            }
          }

          if (this.content.ReceivableList && this.content.ReceivableList.length > 0) {
            for (var item of this.content.ReceivableList) {
              this.getDic(item);
            }
          }

          console.log(this.content);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getDic(data) {
      var test1 = Object.entries(data.TotalAmountDic);
      var array1 = test1.map(([key, value]) => ({
        key,
        value,
      }));
      data.TotalAmountList = array1;

      var test2 = Object.entries(data.BalanceAmountDic);
      var array2 = test2.map(([key, value]) => ({
        key,
        value,
      }));
      data.BalanceAmountList = array2;
    },
    deleteSupplierCostDetails(id) {
      var param = {
        FinancialAccountNo: id,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .deleteSupplierCostDetails(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.getList();
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteCollectionBill(id) {
      var param = {
        InvoiceNo: id,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .deleteCollectionBill(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.getList();
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.tradeOrderReconciliation {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-form {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .van-cell::after {
      border: none !important;
    }
  }
  ::v-deep .van-collapse {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .van-cell::after {
      border: none !important;
    }
    .van-collapse-item--border::after {
      border: none !important;
    }
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 15px;
    background: transparent;
    border-bottom: 1px solid #ebedf0;
  }
  .cost-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e4f6f0;
    color: #20b2aa;
    border: 2px solid #20b2aa;
  }
  .sale-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e8f4ff;
    color: #1e90ff;
    border: 2px solid #87ceeb;
  }
  .empty-text {
    text-align: center;
    padding: 30px;
    font-size: 14px;
    color: #969799;
  }
  .collapse-item {
    font-size: 12px;
    margin-bottom: 5px;
  }
  .collapse-buttons {
    margin-top: 15px;
    text-align: center;
    .van-button:first-child {
      margin-right: 10px;
    }
  }
  .collapse-currency {
    font-size: 12px;
    margin-bottom: 5px;
    .collapse-label {
      margin-bottom: 5px;
    }
    .collapse-amount {
      display: inline-block;
      width: 33.33%;
    }
  }
  .subTotal {
    padding: 15px;
    font-size: 12px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      font-size: 12px;
      .item1 {
      }
      .item2 {
        padding-top: 15px;
      }
    }
  }
  .rate {
    border-top: 1px solid #ebedf0;
    padding: 15px;
    font-size: 12px;
    color: #646566;
    .rate-label {
      margin-bottom: 15px;
    }
    .rate-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      font-size: 12px;
      .item1 {
      }
      .item2 {
        padding-top: 15px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
